<div class="form-group" [formGroup]="group">
    <label>{{field.label}}</label>
    <p-multiSelect  [formControlName]="field.name" [options]="options"></p-multiSelect>
    <app-error-validation-messages [group]="group" [field]="field"></app-error-validation-messages>
</div>
